import { Box, TextField, Button, Typography, Grid, Card, Snackbar, Alert } from '@mui/material';
import React from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

import { FormValues, FeedbackProps } from './Notification.container';

interface NotificationProps {
  onSubmit: () => void;
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  feedback: FeedbackProps | null;
  onCloseFeedback: () => void;
  isAuthenticated: boolean;
  isPending: boolean;
}

export const Notification: React.FC<NotificationProps> = ({
  onSubmit,
  register,
  errors,
  feedback,
  onCloseFeedback,
  isAuthenticated,
  isPending,
}) => (
  <Box>
    <Card
      sx={{
        py: 2,
        px: 6,
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography align="center" variant="h5" gutterBottom>
            Enviar Notificação
          </Typography>
          <hr />

          {isAuthenticated ? (
            <form onSubmit={onSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="CPF"
                    variant="outlined"
                    fullWidth
                    {...register('cpf')}
                    error={!!errors.cpf}
                    helperText={errors.cpf?.message}
                    inputProps={{ maxLength: 11 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Mensagem de Notificação"
                    variant="outlined"
                    fullWidth
                    {...register('message')}
                    error={!!errors.message}
                    helperText={errors.message?.message}
                    multiline
                    rows={4}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" color="primary" fullWidth disabled={isPending}>
                    {isPending ? 'Enviando...' : 'Enviar'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          ) : (
            <Typography variant="subtitle1" align="center">
              Inicie a sessão para enviar uma notificação.
            </Typography>
          )}
        </Grid>
      </Grid>
    </Card>

    {feedback && (
      <Snackbar open={true} autoHideDuration={4000} onClose={onCloseFeedback}>
        <Alert onClose={onCloseFeedback} severity={feedback.type} sx={{ width: '100%' }}>
          {feedback.message}
        </Alert>
      </Snackbar>
    )}
  </Box>
);
